export { default as Hero } from './Hero';
export { default as Header } from './HeroHeader';
export { default as Video } from './HeroVideo';
export { default as Body } from './HeroBody';
export { default as Footer } from './HeroFooter';


// WEBPACK FOOTER //
// ./src/layout/Hero/index.ts